import { useKeycloak } from "@/hooks/useKeycloak";
import { router } from "@/router";
import { RouterProvider } from "@tanstack/react-router";

export default function AuthRouterProvider() {
  const { keycloak } = useKeycloak();

  return <RouterProvider router={router} context={{ auth: keycloak }} />;
}
